import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setSortType, setSortOrder, getSortedProducts } from '../modules/sort';

class SortByBox extends Component {

    constructor(props) {
        super(props);
        this.state = { activeNav: '' };
        this.onItemClick       = this.onItemClick.bind(this);
        this.toggleActiveNav   = this.toggleActiveNav.bind(this);
    }


    toggleActiveNav(sNav) {
        let sCurrentNav = this.state.activeNav;
        if (sCurrentNav.toString() === sNav.toString()) sNav = '';
        this.setState({activeNav: sNav});
    }

    onItemClick(evt) {
        if(evt.target.parentElement.parentElement.id == "sort-by")
            this.props.dispatch( setSortType( evt.target.dataset.value ));
        else
            this.props.dispatch( setSortOrder( evt.target.dataset.value ));
        this.props.dispatch( getSortedProducts() );
        this.setState({activeNav: ''});
    }

    render() {
        let tla = this.props.tla;
        let orders = [{display: "Ascending", value: "ascending"}, {display: "Descending", value: "descending"}];
        let sorts = [{display: "Recommended", value: "recommended"}, {display: (tla === "DVD" ? "Actor" : "Author"), value: "author"},
            {display: "Title", value: "title"}, {display: "Release Date", value: "release-date"}];

        let ordersList = orders.map(order => {
            let orderClassName = '';
            if (this.props.sort.order == order.value) orderClassName = "active";
            return (
                <li key={order.value}>
                    <a
                        className={orderClassName}
                        data-value={order.value}
                        onClick={this.onItemClick}
                    >
                        {order.display}
                    </a>
                </li>
            );
        });
        let sortsList = sorts.map(sort => {
            let sortClassName = '';
            if (this.props.sort.type == sort.value) sortClassName = "active";
            return (
                <li key={sort.value}>
                    <a
                        className={sortClassName}
                        data-value={sort.value}
                        onClick={this.onItemClick}
                    >
                        {sort.display}
                    </a>
                </li>
            );
        });
        return (
            <div className="sort-wrap">
                <div className = "mobile-nav-wrapper">
                    <div
                        className = {"mobile-nav-toggler left" + ( this.state.activeNav === 'sortorder' ? " active" : "" )}
                        onClick   = {this.toggleActiveNav.bind( this, 'sortorder' )}
                    >
                        <div className="arrow down"></div>
                        <h6>Sort By</h6>
                    </div>
                    <div
                        className = {"mobile-nav-toggler " + ( this.state.activeNav === 'sorttype' ? " active" : "" )}
                        onClick   = {this.toggleActiveNav.bind( this, 'sorttype' )}
                    >
                        <div className="arrow down"></div>
                        <h6>Order By</h6>
                    </div>
                </div>
                <div className={"order-by-box"  +( this.state.activeNav === 'sorttype' ? " showing" : " hidden" )}>
                    <div className="">
                        <span>Order By</span><div className="arrow down"></div>
                    </div>
                    <ul id="order-by">
                        {ordersList}
                    </ul>
                </div>
                <div className={"sort-by-box" + ( this.state.activeNav === 'sortorder' ? " showing" : " hidden" )}>
                    <div className="">
                        <span>Sort By</span><div className="arrow down"></div>
                    </div>
                    <ul id="sort-by">
                        {sortsList}
                    </ul>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state){
    return { 'products'  : state.products, 'sort': state.sort, 'tla': state.store.tla };
}

export default connect(mapStateToProps)(SortByBox);


// WEBPACK FOOTER //
// ./src/components/SortByBox.jsx